// extracted by mini-css-extract-plugin
export var root = "_1d4735cfd825a29d3c1ff8056d6448b9-css";